import { render, staticRenderFns } from "./SNC.vue?vue&type=template&id=08191864&scoped=true"
import script from "./SNC.vue?vue&type=script&lang=ts"
export * from "./SNC.vue?vue&type=script&lang=ts"
import style0 from "./SNC.vue?vue&type=style&index=0&id=08191864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08191864",
  null
  
)

export default component.exports